import { render } from "./SentPushNotifications.vue?vue&type=template&id=2ac2ba1f&scoped=true"
import script from "./SentPushNotifications.vue?vue&type=script&lang=js"
export * from "./SentPushNotifications.vue?vue&type=script&lang=js"

import "./SentPushNotifications.vue?vue&type=style&index=0&id=2ac2ba1f&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac2ba1f"]])

export default __exports__